import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { DataExtenso } from "../../../../components/Formatters/DateTime";
import removeHTML from "../components/RemoveHTML";

const useProrrogacaoModal = () => {
  const [prorrogacaoModalShow, setProrrogacaoModalShow] = useState(false);
  const [conteudo, setConteudo] = useState(null);

  const dataRodape = (
    <div style={{ marginTop: 70, textAlign: "center" }}>
      <p style={{ marginBottom: 60 }}>
        <DataExtenso value={new Date()} />
      </p>
    </div>
  );

  const prorrogacaoModal = (
    <Modal size="lg" show={prorrogacaoModalShow} onHide={() => setProrrogacaoModalShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Prorrogação da OS (Pré-Visualização)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <br />
        <Form.Group className="m-0" style={{ marginTop: 30 }}>
          <h4 style={{ textAlign: "center" }}>SOLICITAÇÃO DE PEDIDO DE PRORROGAÇÃO</h4>
          <p style={{ marginTop: 20 }}>
            {conteudo !== null
              ? removeHTML(
                  conteudo?.textoPadrao.replace("[NUMOS]", conteudo.dadosOs.sequencial).replace("[JUSTIFICATIVA]", ""),
                )
              : ""}
            {removeHTML(conteudo?.texto)}
            {dataRodape}
          </p>

          <Modal.Footer>
            <Button style={{ marginTop: 15 }} variant="primary" onClick={() => setProrrogacaoModalShow(false)}>
              Fechar
            </Button>
          </Modal.Footer>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );

  return {
    prorrogacaoModal,
    setProrrogacaoModalShow,
    setConteudo,
  };
};

export default useProrrogacaoModal;
